import { motion } from "framer-motion";
import { MANIFESTO } from "../lib/brand";

const row = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Manifesto = () => {
  return (
    <section
      id="story"
      className="relative py-16 sm:py-24 lg:py-32 bg-[#131311] text-[#faf9f5] lj-grain overflow-hidden"
      data-testid="manifesto-section"
    >
      <div className="pointer-events-none absolute top-0 right-0 h-[400px] w-[400px] rounded-full bg-[radial-gradient(circle,rgba(197,160,89,0.16),transparent_65%)]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 relative">
        <div className="grid lg:grid-cols-[0.8fr_1.2fr] gap-12 lg:gap-20">
          <div className="lg:sticky lg:top-28 self-start">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#c5a059]" />
              <span className="text-xs tracking-[0.34em] uppercase text-[#c5a059] font-semibold">
                Why Families Choose Us
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1]">
              A quiet promise,
              <br />
              <span className="italic text-gold-gradient">kept for years.</span>
            </h2>
            <p className="mt-6 max-w-md text-[#c9c4b6] leading-relaxed">
              Real estate in Hisar runs on trust. For a generation, Laxmi Jiwan
              Properties has earned it — one honest deal at a time.
            </p>
          </div>

          <div className="divide-y divide-[#2e2c26]">
            {MANIFESTO.map((m, i) => (
              <motion.div
                key={m.n}
                custom={i}
                variants={row}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-80px" }}
                className="group flex gap-6 lg:gap-10 py-8 lg:py-10"
              >
                <span className="font-serif text-4xl lg:text-5xl text-[#5a564b] group-hover:text-gold-gradient transition-colors duration-500 shrink-0 w-16">
                  {m.n}
                </span>
                <div>
                  <h3 className="font-serif text-2xl lg:text-3xl font-semibold text-[#faf3e0]">
                    {m.title}
                  </h3>
                  <p className="mt-3 text-[#c9c4b6] leading-relaxed max-w-xl">
                    {m.body}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
